module.exports = __webpack_public_path__ + "static/avatar-ea4a257d64e050ea1025297f93e08209.jpg";